import { FunctionComponent, useMemo } from 'react';

interface TenderFormTitleProps {
  title: string;
  description?: string;
  useHeaderTag: boolean;
}

const TenderFormTitle: FunctionComponent<TenderFormTitleProps> = ({
  title,
  description,
  useHeaderTag,
}) => {
  const headerClasses = useMemo(() => {
    return 'text-semibold text-2xl';
  }, []);
  return (
    <div className="mb-8">
      {useHeaderTag ? (
        <h1 className={headerClasses}>{title}</h1>
      ) : (
        <span className={headerClasses}>{title}</span>
      )}

      {description ? (
        <p className="mt-1 text-slate-500">{description}</p>
      ) : null}
    </div>
  );
};

export default TenderFormTitle;
